module.exports = __webpack_public_path__ + "static/media/ganirelix-thumb.b7671377.jpg";